<script>
export default {
  name: "GtIconTooltip",

  functional: true,

  render(h, ctx) {
    const {
      // 废弃
      placement, // 该api废弃 不要继续使用
      trigger, // 该api废弃 不要继续使用
      popperClass, // 该api废弃 不要继续使用
      content, // 该api废弃 不要继续使用
      icon, // 该api废弃 不要继续使用
      size, // 该api废弃 不要继续使用

      // 不推荐
      label = "", // 不推荐使用

      // 新api
      tooltipProps = {}, //  el-tooltip's props
      iconProps = {} //  el-icon's props
    } = ctx.props;

    const childVNodes = ctx.children;

    // 向后兼容语法
    const toolTipProps = Object.assign(
      // default
      {
        placement: placement || "bottom-start",
        trigger: trigger || "hover",
        popperClass: popperClass || "gt-icon-tooltip",
        content: content || "",
        effect: "light"
      },

      // new props api
      tooltipProps
    );

    function iconSlotComponent() {
      const children = [
        h("i", {
          style: {
            "margin-left": "4px",
            "font-size": iconProps.size || size || undefined // 兼容写法
          },
          class: iconProps.name || icon || "el-icon-warning-outline" // 兼容写法
        })
      ];

      if (childVNodes) {
        children.push(
          h(
            "div",
            {
              slot: "content"
            },
            childVNodes
          )
        );
      }

      return children;
    }

    function iconTooltipComponent() {
      return h(
        // tag
        "el-tooltip",

        // data
        {
          props: toolTipProps
        },

        iconSlotComponent()
      );
    }

    return label
      ? h("p", [
          h("span", { style: { "margin-right": "4px" } }, label),
          iconTooltipComponent()
        ])
      : iconTooltipComponent();
  }
};
</script>

<style lang="scss">
.gt-icon-tooltip.el-tooltip__popper {
  max-width: unset;
}
</style>
